module.exports = __webpack_public_path__ + "assets/img/Bedstitest_RMI632_logoSPLASH_RGB_2.747133e5.png";